import React, { useState, useEffect } from 'react';
import { featureFlagAPI } from '../utils/api';

const AdminFeatureFlags = () => {
    const [flags, setFlags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [updatingFlag, setUpdatingFlag] = useState(null);

    useEffect(() => {
        fetchFlags();
    }, []);

    const fetchFlags = async () => {
        try {
            setLoading(true);
            const response = await featureFlagAPI.getAll();
            setFlags(response.data);
        } catch (err) {
            setError(err.message);
            console.error('Error fetching feature flags:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleFlag = async (flagName) => {
        try {
            setUpdatingFlag(flagName);
            const currentFlag = flags.find(f => f.name === flagName);
            
            const response = await featureFlagAPI.update(flagName, {
                enabled: !currentFlag.enabled
            });

            setFlags(flags.map(f => f.name === flagName ? response.data : f));
        } catch (err) {
            setError(err.message);
            console.error('Error updating feature flag:', err);
        } finally {
            setUpdatingFlag(null);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center py-12">
                <p className="text-gray-600">Loading feature flags...</p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow">
            <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-xl font-light text-black">Feature Flags</h2>
                <p className="text-sm text-gray-600 font-light mt-1">Control which features are available to users</p>
            </div>

            {error && (
                <div className="mx-6 mt-4 p-4 bg-red-50 border border-red-200 text-red-700 text-sm">
                    {error}
                </div>
            )}

            <div className="p-6">
                <div className="space-y-4">
                    {flags.length === 0 ? (
                        <p className="text-center text-gray-500 py-8">No feature flags found</p>
                    ) : (
                        flags.map(flag => (
                            <div key={flag.name} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors">
                                <div className="flex-1">
                                    <h3 className="font-light text-black capitalize">{flag.name.replace(/_/g, ' ')}</h3>
                                    <p className="text-sm text-gray-600 font-light mt-1">
                                        {flag.description}
                                    </p>
                                    {flag.updatedAt && (
                                        <p className="text-xs text-gray-500 mt-2">
                                            Last updated: {new Date(flag.updatedAt).toLocaleDateString()}
                                        </p>
                                    )}
                                </div>

                                <button
                                    onClick={() => handleToggleFlag(flag.name)}
                                    disabled={updatingFlag === flag.name}
                                    className={`ml-4 px-6 py-2 rounded font-light text-sm transition-all whitespace-nowrap ${
                                        flag.enabled
                                            ? 'bg-green-100 text-green-800 hover:bg-green-200'
                                            : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
                                    } ${updatingFlag === flag.name ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                    {updatingFlag === flag.name ? 'Updating...' : flag.enabled ? 'Enabled' : 'Disabled'}
                                </button>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminFeatureFlags;
